import {
  defineCborSchema,
  CborField,
  type CborSchema,
} from '@mesh/friendly-cbor-serializer'
import { Id } from '../../../aliases'

export type AuthenticateSessionResponsePayload = {
  challenges: number[]
  anonymousIdentityLinkCode?: Id
}

export const AuthenticateSessionResponsePayloadSchema: CborSchema<AuthenticateSessionResponsePayload> =
  defineCborSchema<AuthenticateSessionResponsePayload>({
    challenges: CborField({ key: 0 }),
    anonymousIdentityLinkCode: CborField({ key: 7, required: false }),
  })
